<template>
  <button
    class="p-button"
    :class="[
      `p-button--${type}`,
      `p-button--${size}`,
      {
        'is-disabled': disabled,
        'is-loading': loading,
        'is-round': round,
        'is-circle': circle,
        'is-plain': plain,
        'is-block': block,
      },
    ]"
    :disabled="disabled || loading"
    @click="handleClick"
  >
    <LoadingIcon v-if="loading" class="p-button__loading-icon" />
    <i v-if="icon && !loading" :class="icon" class="p-button__icon" />
    <span v-if="$slots.default" :class="{ 'is-loading': loading }" class="p-button__content">
      <slot />
    </span>
  </button>
</template>

<script lang="ts">
import './style/index.less'

import type { PropType } from 'vue'

import { defineComponent } from 'vue'

import type { ButtonSize, ButtonType } from './types'

import LoadingIcon from '../Icon/Loading.vue'

export default defineComponent({
  name: 'PButton',
  components: {
    LoadingIcon,
  },
  props: {
    type: {
      type: String as PropType<ButtonType>,
      default: 'default',
    },
    size: {
      type: String as PropType<ButtonSize>,
      default: 'medium',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const handleClick = (evt: MouseEvent) => {
      if (props.disabled || props.loading) {
        return
      }
      emit('click', evt)
    }

    return {
      handleClick,
    }
  },
})
</script>
